export function disableReactDevTools(): void {
  if (typeof window === "undefined") return;
  const globalWindow = window as unknown as Record<string, unknown>;
  const hookKey = "__REACT_DEVTOOLS_GLOBAL_HOOK__";

  const hook = globalWindow[hookKey] as Record<string, unknown> | undefined;

  if (hook && typeof hook === "object") {
    const noop = () => {};
    try {
      // Clear known fields used by DevTools and React reconciler integrations
      (hook as Record<string, unknown>).renderers = new Map();
      (hook as Record<string, unknown>).inject = noop;
      (hook as Record<string, unknown>).onCommitFiberRoot = noop;
      (hook as Record<string, unknown>).onCommitFiberUnmount = noop;
      (hook as Record<string, unknown>).emit = noop;
      (hook as Record<string, unknown>).on = noop;
      (hook as Record<string, unknown>).off = noop;
    } catch {
      // Best-effort; ignore if the hook is not writable
    }
  }

  try {
    // Attempt to remove the hook entirely
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete (globalWindow as any)[hookKey];
  } catch {
    // ignore
  }

  // As a harden fallback, define an inert, frozen hook object if the property
  // is still present or gets re-added by an extension later in the page life-cycle.
  try {
    Object.defineProperty(globalWindow, hookKey, {
      value: Object.freeze({
        renderers: new Map(),
        inject: () => {},
        onCommitFiberRoot: () => {},
        onCommitFiberUnmount: () => {},
        emit: () => {},
        on: () => {},
        off: () => {},
      }),
      configurable: false,
      enumerable: false,
      writable: false,
    });
  } catch {
    // Ignore if we cannot redefine; best effort already applied above
  }
}
